var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c("div", { staticClass: "quote-tool" }, [
            _c("header", { staticClass: "quote-tool__header" }, [
              _c("div", { staticClass: "container top-container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row flex-row align-items-start align-items-md-center flex-nowrap",
                  },
                  [
                    _c("div", { staticClass: "col col-sm-auto" }, [
                      _c(
                        "a",
                        { staticClass: "main-logo", attrs: { href: "/" } },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: "/media/ukieam2m/sfb-logo-high-res-rgb.jpg",
                              height: "90",
                              width: "178",
                              alt: "Source for Business - Logo",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "top-container__tagline col-sm-7" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "s4b__strapline d-none d-lg-inline-block",
                          },
                          [_vm._v(_vm._s(_vm.labels.headerTagLine))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col col-xl-auto d-flex justify-content-end",
                      },
                      [
                        _c("div", { staticClass: "top-container__right" }, [
                          _c(
                            "span",
                            { staticClass: "top-container__right-heading" },
                            [_vm._v(_vm._s(_vm.labels.headerHelpIntro))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "top-container__right-call-us" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `tel:${_vm.labels.headerPhoneNumberNumber}`,
                                    title: _vm.labels.headerPhoneNumber,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.labels.headerPhoneNumber))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-container__right-opening-times",
                            },
                            [_vm._v(_vm._s(_vm.labels.headerOpeningTimes))]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.currentStepComponent == "IntroStep"
              ? _c(
                  "div",
                  [
                    _c("step-header", { attrs: { nav: false } }),
                    _vm._v(" "),
                    _c("intro-step"),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("step-header"),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c(_vm.currentStepComponent, { tag: "component" })],
                      1
                    ),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }